/**
 * FH-A11Y batch 22 (2026-09-30): collection filters (Globo Smart Product Filter), from Kanan's filter audit.
 * Same sidebar and drawer design; adds what screen readers were missing:
 *   1. A visible "Filter By" heading at the top of the desktop sidebar, and the sidebar is a region named by it.
 *      The mobile drawer (a dialog) is named by the same heading.
 *   2. The group titles (Material, Size, Price, Color, Brand) are level-3 headings, so screen reader users can
 *      jump between groups. They don't collapse, so they stay plain headings (no expand/collapse button needed).
 *   3. Price is a labeled group ("Price"), and its two boxes read "Minimum price" / "Maximum price".
 *   4. After each filter change, the number of products is announced ("40 products", "No products found").
 * Works with ada-a11y-fixes.js (checkbox options, drawer focus) and batches 8, 12, 15, 16 and 19.
 * Rollback: remove the batch 22 line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch22) return;
  window.__fhA11yBatch22 = true;

  var HEAD_ID = 'gf-filter-title';

  function setAttr(el, name, value) {
    if (el && el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function addStyles() {
    if (document.getElementById('fh-a11y-batch22-css')) return;
    var st = document.createElement('style');
    st.id = 'fh-a11y-batch22-css';
    st.textContent =
      /* Desktop sidebar: show Globo's own "Filter By" header (hidden there by default) without its close button. */
      '#gf-tree[role="region"] .gf-filter-header{display:block!important;padding:0!important;margin:0 0 16px!important;' +
      'border:0!important;background:none!important;position:static!important;height:auto!important}' +
      '#gf-tree[role="region"] .gf-close-canvas{display:none!important}' +
      '#gf-tree[role="region"] .gf-filter-heading{display:block!important;margin:0!important;padding:0!important;' +
      'font-size:18px!important;line-height:1.3!important;font-weight:700!important;letter-spacing:0!important;' +
      'text-transform:none!important;color:#333!important;text-align:left!important}' +
      /* Once filters are chosen Globo repeats "Filter By" above the chips: keep only the Clear All link there. */
      '#gf-tree[role="region"] .globo-selected-items-wrapper .gf-block-title .h3{display:none!important}' +
      '.fh-gf-sr{position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;padding:0!important;' +
      'overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important;border:0!important}';
    document.head.appendChild(st);
  }

  /* 1 + 2 + 3: names and headings */
  function fixTree() {
    var tree = document.getElementById('gf-tree');
    if (!tree) return;
    addStyles();
    var head = tree.querySelector('.gf-filter-heading');
    if (head) {
      var other = document.getElementById(HEAD_ID);
      if (!other || other === head) {
        setAttr(head, 'id', HEAD_ID);
        setAttr(head, 'role', 'heading');
        setAttr(head, 'aria-level', '2');
      }
    }
    var role = tree.getAttribute('role');
    if (role !== 'dialog') {
      /* Desktop: Globo gives the sidebar no role. */
      if (head && role !== 'region') tree.setAttribute('role', 'region');
      if (head) setAttr(tree, 'aria-labelledby', HEAD_ID);
    }

    tree.querySelectorAll('.gf-option-block').forEach(function (block) {
      var title = block.querySelector(':scope > .gf-block-title');
      if (!title) return;
      var inner = title.querySelector('.h3') || title;
      if (!inner.matches('h1,h2,h3,h4,h5,h6')) {
        setAttr(inner, 'role', 'heading');
        setAttr(inner, 'aria-level', '3');
      }
      if (!title.id && block.getAttribute('data-filter-id')) title.id = 'fh-gf-title-' + block.getAttribute('data-filter-id');

      if (block.classList.contains('gf-option-block-slider')) {
        var content = block.querySelector(':scope > .gf-block-content');
        if (content && title.id) {
          setAttr(content, 'role', 'group');
          setAttr(content, 'aria-labelledby', title.id);
        }
        var min = block.querySelector('input.gf-range-min');
        var max = block.querySelector('input.gf-range-max');
        var isPrice = /price/i.test((title.textContent || '') + (block.getAttribute('data-filter-type') || ''));
        var noun = isPrice ? 'price' : (title.textContent || '').trim().toLowerCase();
        if (min) setAttr(min, 'aria-label', 'Minimum ' + noun);
        if (max) setAttr(max, 'aria-label', 'Maximum ' + noun);
      }
    });
  }

  /* 4: product count after each filter change */
  var status = null;
  var lastKey = null;
  var pending = 0;
  function ensureStatus() {
    if (status && document.body.contains(status)) return status;
    status = document.createElement('div');
    status.id = 'fh-gf-status';
    status.className = 'fh-gf-sr';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    document.body.appendChild(status);
    return status;
  }
  function total() {
    try {
      var t = window.globofilter && globofilter.state && globofilter.state.pagination && globofilter.state.pagination.total;
      if (typeof t === 'number' && isFinite(t)) return t;
      if (typeof t === 'string' && /^\d+$/.test(t)) return parseInt(t, 10);
    } catch (e) {}
    return null;
  }
  function announce() {
    if (!document.getElementById('gf-grid')) return;
    var n = total();
    if (n === null) return;
    var key = location.search + '|' + n;
    if (lastKey === null) { lastKey = key; ensureStatus(); return; } /* page load: nothing to announce */
    if (key === lastKey) return;
    lastKey = key;
    var s = ensureStatus();
    s.textContent = ''; /* clear first so a repeat count is read again */
    /* Batch 28 (2026-10-05): the count used to be written about 100 ms before keyboard focus came back to the
       filter, so the screen reader dropped it to read the filter instead. Now wait until the products have
       loaded and focus is back, then write the count (read fresh, so it is never a stale number). */
    clearTimeout(pending);
    var tries = 0;
    (function wait() {
      var a = document.activeElement;
      var cl = document.documentElement.classList;
      var busy = (a && a.id === 'fh-a11y-focus-sink') || cl.contains('spf-filter-loading') || cl.contains('gf-loading');
      if (busy && tries++ < 30) { pending = setTimeout(wait, 150); return; }
      pending = setTimeout(function () {
        var m = total();
        if (m === null) m = n;
        lastKey = location.search + '|' + m;
        s.textContent = m === 0 ? 'No products found' : (m === 1 ? '1 product' : m + ' products');
      }, 700);
    })();
  }

  /* 5 (batch 28): with a screen reader in browse mode, Space or Enter on a filter arrives as a click on the
     list item itself, not as a key press, and nothing was listening for it. Pass it on to the filter's link. */
  document.addEventListener('click', function (e) {
    var li = e.target;
    if (!li || li.nodeType !== 1 || !li.matches('#gf-tree li[role="checkbox"]')) return;
    var a = li.querySelector(':scope > a');
    if (a) a.click();
  }, true);

  var timer = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = 0;
      try { fixTree(); } catch (e) {}
      try { announce(); } catch (e) {}
    }, 300);
  }
  function start() {
    /* The filter app adds its sidebar after the page loads, so keep watching (nothing happens on pages without it). */
    schedule();
    /* Globo rebuilds the sidebar and the product grid after each change. */
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
